// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2bErp","tab":"ProcedureTabs_tab__Urgs_"};